var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 16.25H1.875C0.85 16.25 0 15.4 0 14.375C0 13.35 0.85 12.5 1.875 12.5H30.625C31.65 12.5 32.5 13.35 32.5 14.375C32.5 15.4 31.65 16.25 30.625 16.25Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 36.25H11.875C10.85 36.25 10 35.4 10 34.375C10 33.35 10.85 32.5 11.875 32.5H16.875C17.9 32.5 18.75 33.35 18.75 34.375C18.75 35.4 17.9 36.25 16.875 36.25Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 36.25H23.125C22.1 36.25 21.25 35.4 21.25 34.375C21.25 33.35 22.1 32.5 23.125 32.5H33.125C34.15 32.5 35 33.35 35 34.375C35 35.4 34.15 36.25 33.125 36.25Z",
    fill: "#026C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.775 46.25H12.975C3.025 46.25 0 43.25 0 33.4V12.85C0 3 3.025 0 12.975 0H30.625C31.65 0 32.5 0.85 32.5 1.875C32.5 2.9 31.65 3.75 30.625 3.75H12.975C5.125 3.75 3.75 5.1 3.75 12.85V33.375C3.75 41.125 5.125 42.475 12.975 42.475H40.75C48.6 42.475 49.975 41.125 49.975 33.375V23.175C49.975 22.15 50.825 21.3 51.85 21.3C52.875 21.3 53.725 22.15 53.725 23.175V33.375C53.75 43.25 50.725 46.25 40.775 46.25Z",
    fill: "#026C96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.875 10.625H38.125C37.1 10.625 36.25 9.775 36.25 8.75C36.25 7.725 37.1 6.875 38.125 6.875H51.875C52.9 6.875 53.75 7.725 53.75 8.75C53.75 9.775 52.9 10.625 51.875 10.625Z",
    fill: "#026C96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17.5C43.975 17.5 43.125 16.65 43.125 15.625V1.875C43.125 0.85 43.975 0 45 0C46.025 0 46.875 0.85 46.875 1.875V15.625C46.875 16.65 46.025 17.5 45 17.5Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.ae21955cd71e147889e5abc4b24d5c9f.svg";
export { ForwardRef as ReactComponent };